<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";

  export let placeholder = "";
  export let label = "";
  export let checked = false;
  export let group = "";
  export let type = "";
  export let name = "";
  export let value = "";
  export let variant = "body2";
  export let light = false;
</script>

<style lang="scss">
  .checkbox,
  .radio {
    display: flex;
    cursor: pointer;
    position: relative;
  }

  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
  }

  input[type="checkbox"] {
    display: none;
  }

  input[type="radio"] {
    height: 20px;
    width: 20px;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border: 1px solid $on-surface-10;
    border-radius: 100px;
    outline: none;
    transition-duration: 0.2s;
    cursor: pointer;
    padding: 0;
    margin: 0;
  }

  input[type="radio"].radio--light {
    border: 1px solid $inverse-on-surface;
  }

  input[type="radio"]:checked {
    border: 1px solid $on-surface-10;
    background-color: $inverse-surface;
    justify-content: center;
    padding: 4px;
  }

  input[type="radio"]:checked.radio--light {
    border: 1px solid $inverse-on-surface;
    background-color: $inverse-on-surface;
    justify-content: center;
    padding: 4px;
  }

  .checkbox {
    border-radius: 2px;
    display: flex;
    align-items: center;

    &--input {
      width: 24px;
      height: 24px;
    }
  }

  .radio {
    background-clip: content-box;
  }

  .label {
    padding-left: 4px;
  }
</style>

<div />

{#if type === "checkbox"}
  <label class="checkbox">
    <input
      class="checkbox"
      aria-label={label}
      {name}
      {value}
      type="checkbox"
      bind:checked
    />
    <div class="checkbox--input">
      {#if checked}
        <Icon
          icon={light ? "checkbox-filled-light" : "checkbox-filled"}
          customIcon
        />
      {:else}
        <Icon
          icon={light ? "checkbox-blank-light" : "checkbox-blank"}
          customIcon
        />
      {/if}
    </div>
    <div class="label">
      <Typography
        theme={light ? "inverse-on-surface" : "on-background"}
        component="span"
        {variant}>{placeholder}</Typography
      >
    </div>
  </label>
{:else if type === "radio"}
  <label class="radio">
    <input
      class={`radio ${light && "radio--light"}`}
      aria-label={label}
      {name}
      type="radio"
      bind:group
    />
    <div class="label">
      <Typography
        theme={light ? "inverse-on-surface" : "on-background"}
        component="span"
        {variant}>{placeholder}</Typography
      >
    </div>
  </label>
{/if}
<div />
